import { render, staticRenderFns } from "./VerifiedStatus.vue?vue&type=template&id=57abe81f&"
import script from "./VerifiedStatus.vue?vue&type=script&lang=js&"
export * from "./VerifiedStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports